module.exports = __webpack_public_path__ + "img/map-black.9c7320b6.png";